import type { Hub, TimelineEvent, Studios } from './types'

export const chileData = {
  gdneHC: 510,
  territoryDistribution: {
    total: 510,
    regions: [
      { name: 'La Araucanía', hc: 281, percentage: 55 },
      { name: 'Biobío', hc: 87, percentage: 17 },
      { name: 'Metropolitana', hc: 33, percentage: 6 },
      { name: 'Maule', hc: 29, percentage: 6 },
      { name: 'Los Ríos', hc: 20, percentage: 4 },
      { name: 'Otros', hc: 60, percentage: 12 },
    ],
  },
  subco: 99,
  peopleUnderManagement: 609,
  talent: {
    totalHC: 510,
    totalLabel: 'GDN-e',
    managedHC: 609,
    femalePercentage: 15.9,
    roles: [],
  },
  femaleHC: 81,
  femalePercent: 15.9,
  inclusionRate: 2,
  executiveTeam: { total: 6, women: 2, men: 4, femalePercent: 33 },
  capabilities: [
    { name: 'Backend', hc: 227, percent: 44.5 },
    { name: 'Data', hc: 66, percent: 12.9 },
    { name: 'Quality', hc: 53, percent: 10.4 },
    { name: 'Frontend', hc: 47, percent: 9.2 },
  ],
  capabilitiesSummary: { hc: 393, percent: 77 },
  delivery: [
    { name: 'Local', hc: 272, percent: 51 },
    { name: 'Nearshore', hc: 49, percent: 9 },
    { name: 'Offshore', hc: 252, percent: 44 },
  ],
  regions: [
    { region: 'La Araucanía', hc: 281, percent: 55 },
    { region: 'Biobío', hc: 87, percent: 17 },
    { region: 'Metropolitana', hc: 33, percent: 6 },
    { region: 'Maule', hc: 29, percent: 6 },
    { region: 'Los Ríos', hc: 20, percent: 4 },
  ],
}

export const chileTalentPyramid = {
  contributor: { status: 'pending_validation' as const },
  lead: { status: 'pending_validation' as const },
  executive: { hc: 6, femalePercent: 33, status: 'current' as const },
}

export const chileTalentFamilies = [
  { name: 'Engineering', hc: 227 + 47, percent: 44.5 + 9.2, status: 'current' as const },
  { name: 'Quality Assurance', hc: 53, percent: 10.4, status: 'current' as const },
  { name: 'Enterprise Solutions Functional / Others', hc: 66, percent: 12.9, status: 'current' as const },
]

export const chileStudios: Studios = {
  status: 'validated' as const,
  totalTalent: 514,
  specialistTotal: 0,
  focusCount: 3,
  groups: [
    { id: 'backend', name: 'Backend', totalHc: 235, percent: 46 },
    { id: 'data', name: 'Data', totalHc: 77, percent: 15 },
    { id: 'enterprise-platform', name: 'Enterprise Platform', totalHc: 82, percent: 16 },
    { id: 'qa', name: 'QA', totalHc: 58, percent: 11 },
    { id: 'otros', name: 'Otros', totalHc: 62, percent: 12, note: 'Frontend · Agile · Mainframe' },
  ],
  goals: {
    title: 'GOALS',
    items: [
      'DT + GDN-e: integración temprana en oportunidades.',
      'Minería: mayor extensión desde Oficina.',
      'Banco Mundial: +30 HC | 75% extensión GDN-e.',
      'Staff + SUBCO: cobertura de capacidades críticas.',
    ],
  },
  challenges: {
    title: 'DESAFÍOS',
    items: [
      'Minería: avanzar hacia 40% extensión en Q4.',
      'DT Argentina: colaboración desde Chile.',
      'AI Engineering: upskilling + reskilling.',
    ],
  },
}

export const chileHubs: Hub[] = [
  { id: 'temuco', name: 'Temuco', lat: -38.74, lon: -72.59, hc: 281, note: 'La Araucanía · principal concentración regional' },
  { id: 'concepcion', name: 'Concepción', lat: -36.83, lon: -73.05, hc: 87, note: 'Biobío · segundo hub regional' },
]


export const chileHistory: TimelineEvent[] = [
  { year: '2007', title: 'Presencia en Temuco', detail: 'Apuesta por desarrollar una fábrica de software desde regiones' },
  { year: '2015', title: '+250 profesionales', detail: 'Cerca del 70% de la demanda de programación provenía de Europa' },
  { year: '2015', title: 'Hub Digital', detail: 'Nueva etapa de crecimiento para la operación regional' },
  { year: '2016', title: 'Hub operativo', detail: 'Puesta en marcha del proyecto en Temuco' },
]

export const chileCertifications: TimelineEvent[] = [
  { year: '2024', title: '25 personas', detail: 'Base inicial certificada', status: 'current' },
  { year: 'FY25', title: '+112 personas', detail: '82% de aprobación', status: 'current' },
  { year: 'FY26 CURRENT', title: '206 personas', detail: '100% de aprobación a la fecha', status: 'current' },
  { year: 'FY26 AMBITION', title: '332 personas', detail: 'Meta de aprobación igual o superior a 85%', status: 'target' },
]
